// src/pages/ChatWithAI/components/dialogs/AnexarDocumentoDialog.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AnexarDialog.css';

const AnexarDocumentoDialog = ({ onClose, onAnexar }) => {
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    fetchDocumentos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page]);

  const fetchDocumentos = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get('/api/attachments/documentos/list', {
        params: {
          search,
          page,
          limit: 10
        }
      });

      if (response.data.success) {
        if (page === 1) {
          setDocumentos(response.data.data);
        } else {
          setDocumentos(prev => [...prev, ...response.data.data]);
        }
        setHasMore(response.data.pagination.hasMore);
      }
    } catch (err) {
      console.error('❌ Erro ao buscar documentos:', err);
      setError(err.response?.data?.message || 'Erro ao carregar documentos');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
    setDocumentos([]);
  };

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      setPage(prev => prev + 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedDocId) {
      setError('Selecione um documento');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onAnexar(selectedDocId);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="anexar-dialog-overlay" onClick={onClose}>
      <div className="anexar-dialog anexar-dialog-large" onClick={(e) => e.stopPropagation()}>
        <div className="anexar-dialog-header">
          <h3>📝 Anexar Documento Gerado</h3>
          <button onClick={onClose} className="anexar-dialog-close">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="anexar-dialog-content">
          <div className="form-group">
            <label>Pesquisar documentos</label>
            <input
              type="text"
              placeholder="Nome do ficheiro ou tipo..."
              value={search}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>

          <div className="documentos-list-container">
            {loading && page === 1 && (
              <div className="loading-state">
                <div className="spinner"></div>
                <p>Carregando documentos...</p>
              </div>
            )}

            {!loading && documentos.length === 0 && (
              <div className="empty-state">
                <p>Nenhum documento encontrado</p>
              </div>
            )}

            {documentos.length > 0 && (
              <div className="documentos-list">
                {documentos.map((doc) => (
                  <label
                    key={doc.id}
                    className={`documento-item ${selectedDocId === doc.id ? 'selected' : ''}`}
                  >
                    <input
                      type="radio"
                      name="documento"
                      value={doc.id}
                      checked={selectedDocId === doc.id}
                      onChange={() => setSelectedDocId(doc.id)}
                    />
                    <div className="documento-info">
                      <div className="documento-header">
                        <span className="documento-icon">📄</span>
                        <span className="documento-tipo">{doc.tipo_documento}</span>
                      </div>
                      <div className="documento-nome">
                        {truncateText(doc.file_name, 40)}
                      </div>
                      {doc.caso_name && (
                        <div className="documento-caso">
                          📁 {truncateText(doc.caso_name, 30)}
                        </div>
                      )}
                      <div className="documento-meta">
                        <span className="documento-date">
                          {formatDate(doc.created_at)}
                        </span>
                      </div>
                    </div>
                  </label>
                ))}

                {hasMore && !loading && (
                  <button
                    type="button"
                    onClick={handleLoadMore}
                    className="load-more-btn"
                  >
                    Carregar mais
                  </button>
                )}

                {loading && page > 1 && (
                  <div className="loading-more">
                    Carregando...
                  </div>
                )}
              </div>
            )}
          </div>

          {error && (
            <div className="anexar-error">
              ⚠️ {error}
            </div>
          )}

          <div className="anexar-dialog-actions">
            <button
              type="button"
              onClick={onClose}
              className="anexar-btn-cancel"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="anexar-btn-submit"
              disabled={!selectedDocId || loading}
            >
              {loading ? 'Anexando...' : 'Anexar Documento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AnexarDocumentoDialog;